import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { CustomerFormViewProps } from "models/propTypes/customerPropTypes";
import { CustomerFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { CustomerFormSections } from "models/enums/customer";
//#endregion
//#region  components
import { useFormDirtyCheck, useWintForm, WintForm } from "components/common/wintForms";
import DisplaySettingsSection from "./sections/create/displaySettingsSection";
import PaymentSettingsSection from "./sections/create/paymentSettingsSection";
import ReminderSettingsSection from "./sections/create/reminderSettingsSection";
import SendSettingsSection from "./sections/create/sendSettingsSection";
import { CustomerConstants } from "utils/constants";
import useInvoiceSettings from "./sections/create/useInvoiceSettings";
//#endregion

const InvoiceSettingsForm: ForwardRefRenderFunction<FormHandles, CustomerFormViewProps> = (props, ref) => {
  const { wintFormProps, connect, values } = useWintForm<CustomerFormTypes.Create>({
    formRef: ref,
    defaultValues: props.defaultValues,
    validationSchema: props.getValidationSchema(CustomerFormSections.Invoicing),
    handleSubmit: props.handleSubmit,
  });

  React.useEffect(() => {
    props.setNavLayoutSections &&
      props.setNavLayoutSections([
        {
          key: CustomerConstants.SettingsNavKeys.InvoiceManagement,
          label: TranslationKeys.Customer.InvoiceManagement,
        },
        {
          key: CustomerConstants.SettingsNavKeys.Reminders,
          label: TranslationKeys.Settings.Reminders,
        },
        {
          key: CustomerConstants.SettingsNavKeys.Payment,
          label: TranslationKeys.Common.Payment,
        },
        {
          key: CustomerConstants.SettingsNavKeys.Display,
          label: TranslationKeys.Invoice.DisplaySettings,
        },
      ]);
  }, []);

  useFormDirtyCheck(props.defaultValues, values, props.onFormDirtyChange);

  const { invoiceSettings } = useInvoiceSettings();

  return (
    <WintForm {...wintFormProps}>
      <SendSettingsSection connect={connect} invoiceSettings={invoiceSettings} />
      <ReminderSettingsSection connect={connect} invoiceSettings={invoiceSettings} />
      <PaymentSettingsSection connect={connect} />
      <DisplaySettingsSection connect={connect} />
    </WintForm>
  );
};

export default forwardRef(InvoiceSettingsForm);
